import React from 'react';
import { Helmet } from 'react-helmet';
import FooterBar from 'components/FooterBar';
import {Routes, Route, Navigate } from 'react-router-dom'
import BookingsReport from './BookingsReport';
import OccupancyReport from './OccupancyReport';
import DailyReconciliationReport from './DailyReconciliationReport';
import RevenueReport from './RevenueReport';
import PriceTableReport from './PriceTableReport';

const Reports = () => {

  return (
    <>
      <Helmet>
        <title>Reports - Rook Hotel PMS</title>
        <meta name="description" content="Reports - Rook Hotel PMS" />
      </Helmet>
      <div style={{marginTop: "50px"}}>
        <Routes>
          <Route path="" element={<>Report Dashboard</>} />
          <Route
            path={'bookings'}
            element={<BookingsReport />}
          />
          <Route
            path={'occupancy'}
            element={<OccupancyReport />}
          />
          <Route
            path={'daily-reconciliation'}
            element={<DailyReconciliationReport />}
          />
          <Route
            path={'revenue'}
            element={<RevenueReport />}
          />
          <Route
            path={'price-table'}
            element={<PriceTableReport />}
          />
          <Route path="*" element={<Navigate to="/reports" replace/>} />
        </Routes>
      </div>
      <FooterBar />
    </>
  );
};

export default Reports;